import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import classNames from 'classnames';

import * as css from './boolean-tri-state-filter.module.scss';

export interface BooleanTriStateFilterOption {
  key: string;
  label: string;
  // null represents "All" — react-hook-form's Controller falls back to its
  // mount-time default whenever the live value is `undefined`, so callers
  // use `null` as their "All" sentinel instead.
  value: boolean | null;
  colorClassName: string;
}

interface BooleanTriStateFilterControllerProps {
  iconName: string;
  text: string;
  options: BooleanTriStateFilterOption[];
  onChange: (value: boolean | null) => void;
  selectedItem?: boolean | null;
}

export const BooleanTriStateFilterController = ({
  iconName,
  text,
  options,
  onChange,
  selectedItem,
}: BooleanTriStateFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const normalizedSelectedItem = selectedItem ?? null;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText iconName={iconName} text={text} />
      <Stack gap={GapEnum.S} flex={1}>
        {options.map((option) => (
          <button
            key={option.key}
            type="button"
            className={css.buttonTag}
            onClick={() => onChange(option.value)}>
            <Tag
              className={classNames(
                option.colorClassName,
                option.value === normalizedSelectedItem && css.selected,
                css.tag,
              )}>
              {option.label}
            </Tag>
          </button>
        ))}
      </Stack>
    </Stack>
  );
};
